import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Button } from "@website-builder/ui/shared/elements";
import { Spinner, SpinnerWrapper } from "./styles";
const ButtonWithLoader = forwardRef(
	({ darkBg, buttonText, buttonLoading = false, ...restProps }, ref) => {
		if (buttonLoading) {
			buttonText = (
				<SpinnerWrapper>
					Loading <Spinner darkBg={darkBg} />
				</SpinnerWrapper>
			);
		}
		return (
			<Button
				darkBg={darkBg}
				buttonText={buttonText}
				buttonLoading={buttonLoading}
				ref={ref}
				{...restProps}
			></Button>
		);
	},
);

ButtonWithLoader.defaultProps = {
	darkBg: false,
	buttonText: "",
	buttonLoading: false,
};

ButtonWithLoader.propTypes = {
	darkBg: PropTypes.bool,
	buttonText: PropTypes.string,
	buttonLoading: PropTypes.bool,
};

export default ButtonWithLoader;
